import { shape, string } from 'prop-types'

export const CmsContentType = {
  canonicalUrl: string,
  id: string.isRequired,
  name: string.isRequired,
  title: string.isRequired,
  description: string,
  urlMappingForOtherShops: shape({}),
}
